<template>
  <div class="app-main__inner">
    <breadcrumb />
    <div class="row" v-if="isEmpty(selectedDisco) === 0"  style="margin-bottom: 60px;">
      <div class="col-md-3" v-for="disco in discos" :key="disco.id">
        <div
          class="card mb-3 widget-content bg-midnight-bloom"
          @click="getDisco(disco.id)"
        >
          <div class="widget-content-wrapper text-white">
            <div class="widget-numbers text-white">
              <span>{{ disco.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-component :disco="selectedDisco" v-else />
  </div>
</template>
<script>
/* eslint-disable no-undef */
// import AuthenticationService from "@/services/AuthenticationService";
import Breadcrumb from "@/components/_partials/Breadcrumb";
import ContentComponent from "./Content";
export default {
  name: "Power",
  metaInfo: {
    // all titles will be injected into this template
    titleTemplate: "%s | Power",
    meta: [
      {
        name: "description",
        content: "We are coming soon",
      },
      {
        name: "keywords",
        content: "We will fix this soon",
      },
    ],
  },
  components: {
    Breadcrumb,
    ContentComponent
  },
  data() {
    return {
      discos: [
        {
          id: 1,
          name: "AEDC",
          code: "AEDC",
        },
        {
          id: 2,
          name: "AEDC Postpaid",
          code: "AEDC_Postpaid",
        },
        {
          id: 3,
          name: "Ikeja Prepaid",
          code: "Ikeja_Token_Purchase",
        },
        {
          id: 4,
          name: "Ikeja Postpaid",
          code: "Ikeja_Electric_Bill_Payment",
        },
        {
          id: 5,
          name: "Eko Prepaid",
          code: "Eko_Prepaid",
        },
        {
          id: 6,
          name: "Eko Postpaid",
          code: "Eko_Postpaid",
        },
        {
          id: 7,
          name: "Ibadan Prepaid",
          code: "Ibadan_Disco_Prepaid",
        },
        {
          id: 8,
          name: "Kano Prepaid",
          code: "Kano_Electricity_Disco",
        },
        {
          id: 9,
          name: "Kaduna Prepaid",
          code: "Kaduna_Electricity_Disco",
        },
        {
          id: 10,
          name: "Kaduna Postpaid",
          code: "Kaduna_Electricity_Disco_Postpaid",
        },
        {
          id: 11,
          name: "Jos Prepaid",
          code: "Jos_Disco",
        },
        {
          id: 12,
          name: "Jos Postpaid",
          code: "Jos_Disco_Postpaid",
        },
        {
          id: 13,
          name: "Port Harcourt Prepaid",
          code: "PhED_Electricity",
        },
        {
          id: 14,
          name: "Enugu Prepaid",
          code: "EEDC",
        },
      ],
      selectedDisco: {}
    };
  },
  methods: {
    getDisco(value) {
      this.selectedDisco = this.discos.find(item => item.id === value)
    },
    resetDisco() {
      this.selectedDisco = {}
    },
    isEmpty(obj) {
      return Object.entries(obj).length
    }
  },
};
</script>
<style scoped>
.card.mb-3 {
  cursor: pointer;
}
.widget-content {
  flex-direction: column;
}
.widget-content .widget-numbers {
  font-weight: 400;
  font-size: 1rem;
}
</style>
